import axios from 'axios';
import config from 'config';

export default {
    uploadPhoto: (base64File, sessionId, fileName, imageGuid, onProgress, onSuccess) => {
        var byteCharacters = b64toBlob(base64File, "image/png");
        var formDataToUpload = new FormData();
        formDataToUpload.append("image", byteCharacters);
        if (fileName){
            formDataToUpload.append("fileName", fileName);
        }
        axios({
            method: 'post',
            url: `${config.url}/api/Photo?sessionId=${sessionId}&imageGuid=${imageGuid}`,
            data: formDataToUpload,
            config: { headers: {'Content-Type': 'multipart/form-data' }},
            onUploadProgress : (progressEvent) => {
                let progress = Math.round( (progressEvent.loaded * 100) / progressEvent.total );
                onProgress(progress);
                }
            })
            .then((response) => {
                //handle success
                onSuccess(response);
            })
            .catch((response) => {
                //handle error
                console.log("error", response);
            });
    },
    renamePhoto: (targetFileName, newName, sessionId) => {
        return axios({
            method: 'post',
            url: `/api/Photo/Rename?sessionId=${sessionId}&filePath=${targetFileName}&newName=${newName}`,
        });        
    }
}

/**
 * Convert a base64 string in a Blob according to the data and contentType.
 * 
 * @param b64Data {String} Pure base64 string without contentType
 * @param contentType {String} the content type of the file i.e (image/jpeg - image/png - text/plain)
 * @param sliceSize {Int} SliceSize to process the byteCharacters
 * @see http://stackoverflow.com/questions/16245767/creating-a-blob-from-a-base64-string-in-javascript
 * @return Blob
 */
const b64toBlob = (b64Data, contentType, sliceSize) => {
    contentType = contentType || '';
    sliceSize = sliceSize || 512;

    var byteCharacters = atob(b64Data);
    var byteArrays = [];

    for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        var slice = byteCharacters.slice(offset, offset + sliceSize);

        var byteNumbers = new Array(slice.length);
        for (var i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
        }

        var byteArray = new Uint8Array(byteNumbers);

        byteArrays.push(byteArray);
    }

  var blob = new Blob(byteArrays, {type: contentType});
  return blob;
}